import { Converter } from 'emoji-util';

export default new Converter({});
